<template>
  <div>
    <div v-if="documentName" class="file-upload">
      <!-- when we have reference number & document status is available -->
      <span v-if="documentStatus == 'available'" class="file-name" :title="documentName">
        <a :href="getDownloadUrl" target="_blank">
          <span class="fa text-muted fa-lg" :class="fileIcon"></span> {{ documentName }}</a
        >
        <span class="text-danger fa fa-trash fa-lg" @click="removeFile"></span>
      </span>
      <span v-else class="file-name" :title="documentName">
        <span class="fa text-muted fa-lg" :class="fileIcon"></span> {{ documentName }}
        <span class="text-danger fa fa-trash fa-lg" @click="removeFile"></span>
      </span>
    </div>
    <!-- <span class="fa fa-upload"></span> -->
    <label v-if="!documentName" class="btn btn-info btn-sm">
      Upload Document<input id="file" type="file" hidden @change="attachFile($event)" />
    </label>
    <span v-if="!v.required && v.$error" class="text-danger"> This document is required.</span>
    <div v-if="showSizeError" class="text-danger mt">Uploaded file size cannot be 0 or more than 1MB.</div>
    <div v-if="showExtnError" class="text-danger mt">
      Please upload only {{ allowedFileExtns.join(", ") }} format document.
    </div>
  </div>
</template>
<script>
export default {
  props: {
    documentName: {
      type: String,
      default: ""
    },
    documentStatus: {
      type: String,
      default: ""
    },
    documentType: {
      type: String,
      default: ""
    },
    productType: {
      type: String,
      default: ""
    },
    uploadSection: {
      type: String,
      default: ""
    },
    v: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showSizeError: false,
      showExtnError: false,
      allowedFileExtns: ["doc", "docx", "ppt", "pptx", "xls", "xlsx", "xlxs", "pdf", "bmp", "tif", "jpg", "jpeg", "png"]
    };
  },
  computed: {
    getDownloadUrl() {
      let aobNum = this.$store.state.product.referenceNumber;
      let email = this.$store.state.user.user.email;
      let docType = this.documentType == "NameChangeDocument" ? "LegalNameChangeDocument" : this.documentType;
      return "/access/api/aob/downloadDocument?aobRefNo=" + aobNum + "&docType=" + docType + "&email=" + email;
    },
    fileIcon() {
      let icon = "fa-file-text";
      let extn = this.documentName.split(".").pop();

      if (extn === "pdf") {
        icon = "fa-file-pdf-o";
      } else if (extn.includes("doc")) {
        icon = "fa-file-word-o";
      } else if (extn === "zip") {
        icon = "fa-file-archive-o";
      } else if (extn.includes("xls")) {
        icon = "fa-file-excel-o";
      }
      return icon;
    }
  },
  methods: {
    removeFile() {
      switch (this.uploadSection) {
        case "generalInfo": {
          let doc = {
            uploadSection: this.uploadSection,
            productType: this.productType,
            documentType: this.documentType
          };
          this.$store.dispatch("company/removeFileMetaData", doc);
          this.$store.dispatch("files/removeFile", doc.documentType);
          this.v.$touch();
          break;
        }
        case "mro": {
          let doc = {
            uploadSection: this.uploadSection,
            productType: this.productType,
            documentType: this.documentType
          };
          this.$store.dispatch("mro/removeFileMetaData", doc);
          this.$store.dispatch("files/removeFile", doc.documentType);
          this.v.$touch();
          break;
        }
        case "sfgtaGeneralInfo": {
          let doc = {
            uploadSection: this.uploadSection,
            productType: this.productType,
            documentType: this.documentType
          };
          this.$store.dispatch("modifyAgreement/removeFileMetaData", doc);
          this.$store.dispatch("files/removeFile", doc.documentType);
          this.v.$touch();
          break;
        }
        default: {
          let doc = {
            uploadSection: this.uploadSection,
            productType: this.productType,
            documentType: this.documentType
          };
          this.$store.dispatch("product/removeFileMetaData", doc);
          this.$store.dispatch("files/removeFile", doc.documentType);
          this.v.$touch();
        }
      }
    },
    validateFile(file) {
      let fileSize = file.size;
      // allowed file size > 0 and <= 1MB
      if (fileSize == 0 || fileSize > 1000000) {
        this.showSizeError = true;
      }

      let fileExtn = file.name
        .split(".")
        .pop()
        .toLowerCase();
      // check if the extn is allowed, else display error
      let allowedFileExtnsExceptWordExcel = ["ppt", "pptx", "pdf", "bmp", "tif", "jpg", "jpeg", "png"]
      let allowedFileExtnsExceptExcel = ["doc", "docx", "ppt", "pptx", "pdf", "bmp", "tif", "jpg", "jpeg", "png"]
      let docTypeforExceptWordExcel = [
        "CommercialOperatorSpecDocument",
        "OperatorSpecification",
        "FAAPart145RepairStationCertificate",
        "CapabilitiesListDocument",
        "BGAFAAPart145RepairStationCertificate",
        "BGACapabilitiesListDocument"
      ];
      let docTypeforExceptExcel = ["DataProtectionPlanDocument", "BGADataProtectionPlanDocument"];
      if (docTypeforExceptWordExcel.indexOf(this.documentType) !== -1) {
        this.allowedFileExtns = allowedFileExtnsExceptWordExcel;
      }
      if (docTypeforExceptExcel.indexOf(this.documentType) !== -1) {
        this.allowedFileExtns = allowedFileExtnsExceptExcel;
      }
      if (!this.allowedFileExtns.includes(fileExtn)) {
        this.showExtnError = true;
      }
      // returnd true for valid file and false for invalid
      return !(this.showSizeError || this.showExtnError);
    },
    attachFile(e) {
      //clear existing error messages
      this.showSizeError = false;
      this.showExtnError = false;

      let file = e.target.files[0];

      if (this.validateFile(file)) {
        // prepare document object
        let documentData = {
          data: file,
          documentName: file.name,
          documentType: this.documentType,
          documentExtn: file.name.split(".").pop(),
          productType: this.productType,
          action: "add",
          status: ""
        };

        // save file to store
        this.$store.dispatch("files/saveFile", documentData);

        if (this.uploadSection === "generalInfo") {
          this.$store.dispatch("company/saveFileMetaData", documentData);
        } else if (this.uploadSection === "mro") {
          this.$store.dispatch("mro/saveFileMetaData", documentData);
        } else if (this.uploadSection === "sfgtaGeneralInfo") {
          this.$store.dispatch("modifyAgreement/saveFileMetadata", documentData);
        } else {
          this.$store.dispatch("product/saveFileMetaData", documentData);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
[hidden] {
  display: none;
}
.mt {
  margin-top: 5px;
}
.file-upload {
  .file-name {
    height: 30px;
    padding: 5px 10px;
    display: inline-block;
    width: 250px;
    max-width: 250px;
    position: relative;
    padding-right: 35px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: #eee;
    border: 1px solid #aaa;
  }

  .fa-trash {
    position: absolute;
    right: 10px;
    top: 7px;
    cursor: pointer;
  }
}
</style>
